import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import 'LIBRARY/Components/component.css';
import 'LIBRARY/Components/PrintBarcode/PrintBarcode.css';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import ManageTemplate from './ManageTemplate/ManageTemplate';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import InformationModal from 'LIBRARY/CommonResources/InformationModal/InformationModal';
import ReactHtmlParser from 'react-html-parser';
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';

let apiPath = "/api/library/barcodeTemplate.php";

class PrintBarcode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            manageTemplate: false,

            // VARIABLES TO GET ACCESSION SERIES
            accessionSeriesList: {},

            // VARIABLES TO PRINT BARCODE
            printWith: '',
            printWithWarning: '',
            template: '',
            templateWarning: '',
            customHeight: '',
            barcodeHeight: '',
            barcodeWidth: '',
            verticalGap: '',
            horizontalGap: '',
            customHeightWarning: '',
            customWidth: '',
            customWidthWarning: '',
            customDisplayType: '',
            customDisplayTypeWarning: '',
            accessionSeries: '',
            accessionSeriesWarning: '',
            printBy: 'range',
            printByWarning: '',
            startNumber: '',
            startNumberWarning: '',
            endNumber: '',
            endNumberWarning: '',
            seriesNumbers: '',
            seriesNumberIds: [],
            seriesIdsWarning: '',
            numberOfCopiesToPrint: '',
            numberOfCopiesToPrintWarning: '',
            numberOfCopiesInRow: '',
            numberOfCopiesInRowWarning: '',
            numberOfRows: '',
            numberOfRowsWarning: '',
            templateList: {},
            total: 0,
            templateListFetching: false,
            offset: 0,
            selectedTemplate: '',
            printingStartId: '',
            pageHeight: '',
            pageWidth: '',
            pageHeightWarning: '',
            pageWidthWarning: '',
            stickerPageBreak: false,

            defaultTemplate: {
                "1": {
                    "templateName": "14 per A4 sheet: Label Size: 98mm X 38mm",
                    "configuration": {
                        "height": "38",
                        "width": "98",
                        "rows": "7",
                        "columns": "2"
                    }
                },
                "2": {
                    "templateName": "16 per A4 sheet: Label Size: 105mm X 37mm",
                    "configuration": {
                        "height": "37",
                        "width": "105",
                        "rows": "7",
                        "columns": "2"
                    }
                },
                "3": {
                    "templateName": "24 per A4 sheet: Label Size: 70mm X 37mm",
                    "configuration": {
                        "height": "37",
                        "width": "70",
                        "rows": "8",
                        "columns": "3"
                    }
                },
                "4": {
                    "templateName": "33 per A4 sheet: Label Size: 70mm X 27mm",
                    "configuration": {
                        "height": "27",
                        "width": "70",
                        "rows": "11",
                        "columns": "3"
                    }
                },
                "5": {
                    "templateName": "65 per A4 sheet: Label Size: 38mm X 21mm",
                    "configuration": {
                        "height": "21",
                        "width": "38",
                        "rows": "13",
                        "columns": "5"
                    }
                }
            },

            // VARIABLES TO SHOW BARCODE
            showBarcode: false,
            barcodeDetailsFetching: false,
            barcodeDetails: false,
            barcodeIds: [],

            // VARIABLES FOR SUCCESS MODAL
            successModal: false,
            successModalType: '',
            successMessage: ''
        };
    }

    componentDidMount() {

        // METHOD TO GET BARCODE TEMPLATE LIST
        this.apiCallToGetTemplateList();

        // METHOD TO GET ACCESSION SERIES
        this.apiCallToGetAccessionSeries();
    }

    componentDidUpdate() {
        this.replaceBarcode();
    }

    //API CALL METHOD TO GET TEMPLATE LIST
    apiCallToGetTemplateList = async () => {
        this.setState({
            templateListFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "page_index": '',
            "limit": ''
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getBarcodeTemplateList',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetTemplateList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    templateList: apiResult,
                    templateListFetching: false,
                    total: jsonResponse.APIResult.total
                });
            } else {
                this.setState({
                    templateListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting template data. Please try again later.'
                });
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                this.setState({
                    accessionSeriesList: apiResult,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.'
                });
            }
        }
    }

    //METHOD TO SELECT PRINT
    selectPrintWith = (e) => {
        this.setState({
            selectedTemplate: '',
            printWith: e.target.value,
            template: '',
            templateWarning: '',
            customHeight: '',
            customHeightWarning: '',
            customWidth: '',
            customWidthWarning: '',
            customDisplayType: '',
            customDisplayTypeWarning: '',
        });

        if (e.target.value.length < 1) {
            this.setState({
                printWithWarning: 'Please select option to print barcode.'
            });
        } else {
            this.setState({
                printWithWarning: ''
            });

            if (e.target.value == 'template') {
                this.apiCallToGetTemplateList();
            }
        }

    }

    //METHOD TO SELECT TEMPLATE
    selectTemplate = (e) => {
        let templateId = e.target.value;

        if (templateId.length > 0) {
            let templateData = this.state.printWith == "template" ? this.state.templateList[templateId] : this.state.defaultTemplate[templateId];

            let height = templateData['configuration']['height'];
            let width = templateData['configuration']['width'];
            let barcode_height = templateData['configuration']['barcodeHeight'] != undefined ? templateData['configuration']['barcodeHeight'] : 70;
            let barcode_width = templateData['configuration']['barcodeWidth'] != undefined ? templateData['configuration']['barcodeWidth'] : 100;
            let number_of_rows = templateData['configuration']['rows'] != undefined ? templateData['configuration']['rows'] : "";
            let number_of_columns = templateData['configuration']['columns'] != undefined ? templateData['configuration']['columns'] : "";


            this.setState({
                template: e.target.value,
                customHeight: height,
                customWidth: width,
                barcodeHeight: barcode_height,
                barcodeWidth: barcode_width,
                numberOfCopiesInRow: number_of_columns,
                numberOfRows: number_of_rows,
                horizontalGap: templateData['configuration']['horizontalGap'] != undefined ? templateData['configuration']['horizontalGap'] : "",
                verticalGap: templateData['configuration']['verticalGap'] != undefined ? templateData['configuration']['verticalGap'] : "",
                pageHeight: templateData['configuration']['pageHeight'] != undefined ? templateData['configuration']['pageHeight'] : "",
                pageWidth: templateData['configuration']['pageWidth'] != undefined ? templateData['configuration']['pageWidth'] : "",
            });
        }

        if (e.target.value.length < 1) {
            this.setState({
                templateWarning: 'Please select template.'
            });
        } else {
            this.setState({
                templateWarning: ''
            });
        }
    }

    // METHOD TO GET CUSTOM HEIGHT
    getCustomHeight = (e) => {
        this.setState({
            customHeight: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                customHeightWarning: 'Barcode height should be greater than 0.'
            });
        } else {
            this.setState({
                customHeightWarning: ''
            });
        }
    }

    // METHOD TO GET CUSTOM WIDTH
    getCustomWidth = (e) => {
        this.setState({
            customWidth: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                customWidthWarning: 'Barcode width should be greater than 0.'
            });
        } else {
            this.setState({
                customWidthWarning: ''
            });
        }
    }

    // METHOD TO GET CUSTOM HEIGHT
    getBarcodeHeight = (e) => {
        this.setState({
            barcodeHeight: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                customHeightWarning: 'Barcode height should be greater than 0.'
            });
        } else {
            this.setState({
                customHeightWarning: ''
            });
        }
    }

    // METHOD TO GET CUSTOM WIDTH
    getBarcodeWidth = (e) => {
        this.setState({
            barcodeWidth: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                customWidthWarning: 'Barcode width should be greater than 0.'
            });
        } else {
            this.setState({
                customWidthWarning: ''
            });
        }
    }

    // METHOD TO GET PAGE HEIGHT
    getPageHeight = (e) => {
        this.setState({
            pageHeight: e.target.value
        });
    }

    // METHOD TO GET HORIZONTAL GAP
    getHorizontalGap = (e) => {
        this.setState({
            horizontalGap: e.target.value
        });
    }

    // METHOD TO GET VERTICAL GAP
    getVerticalGap = (e) => {
        this.setState({
            verticalGap: e.target.value
        });
    }

    // METHOD TO GET PAGE WIDTH
    getPageWidth = (e) => {
        this.setState({
            pageWidth: e.target.value
        });
    }

    // METHOD TO SELECT ACCESSION SERIES
    selectAccessionSeries = (e) => {
        this.setState({
            accessionSeries: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                accessionSeriesWarning: 'Please select accession series.'
            });
        } else {
            this.setState({
                accessionSeriesWarning: ''
            });
        }
    }

    // METHOD TO SET STICKER PAGE BREAK FLAG
    setStickerPageBreak = (e) => {
        if (e.target.checked) {
            this.setState({
                stickerPageBreak: true
            });
        }
        else {
            this.setState({
                stickerPageBreak: false
            });
        }
    }

    // METHOD TO SELECT PRINT BY OPTION
    selectPrintByOption = (e) => {
        this.setState({
            printBy: e.target.value,
            startNumber: '',
            startNumberWarning: '',
            endNumber: '',
            endNumberWarning: '',
            seriesNumbers: '',
            seriesNumberIds: [],
            seriesIdsWarning: ''
        });

        if (e.target.value.length < 1) {
            this.setState({
                printByWarning: 'Please select print by option.'
            });
        } else {
            this.setState({
                printByWarning: ''
            });
        }
    }

    // METHOD TO SELECT GET START ACCESSION NUMBER
    getStartAccessionNumber = (e) => {
        this.setState({
            startNumber: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                startNumberWarning: 'Start accession number should be greater than 0.'
            });
        } else {
            this.setState({
                startNumberWarning: ''
            });
        }
    }

    // METHOD TO SELECT GET END ACCESSION NUMBER
    getEndAccessionNumber = (e) => {
        this.setState({
            endNumber: e.target.value
        });

        if (e.target.value < 1) {
            this.setState({
                endNumberWarning: 'End accession number should be greater than 0.'
            });
        } else {
            if (this.state.startNumber != '' && this.state.startNumber > 0) {
                if (parseFloat(e.target.value) < parseFloat(this.state.startNumber)) {
                    this.setState({
                        endNumberWarning: 'End accession number should be greater than start accession number.'
                    });
                } else {
                    this.setState({
                        endNumberWarning: ''
                    });
                }
            } else {
                this.setState({
                    endNumberWarning: ''
                });
            }
        }
    }

    // METHOD TO SELECT ACCESSION SERIES NUMBER COMMA SEPERATED 
    getAccessionSeriesNumbers = (e) => {
        this.setState({
            seriesNumbers: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                seriesIdsWarning: 'Please enter comma separated accession series numbers.'
            });
        } else {
            let seriesNumberIds = e.target.value.split(",");

            if (seriesNumberIds.includes("")) {
                this.setState({
                    seriesIdsWarning: 'Please enter value after comma.'
                });
            } else {
                this.setState({
                    seriesIdsWarning: ''
                });
            }

            this.setState({
                seriesNumberIds: seriesNumberIds
            });
        }
    }

    // METHOD TO GET BARCODE NUMBER OF COPIES
    getNumberOfCopiesToPrint = (e) => {
        const value = e.target.value;

        if (value === "") {
            // Allow empty field, show warning
            this.setState({
                numberOfCopiesToPrint: "",
                numberOfCopiesToPrintWarning: "Please enter number of copies."
            });
        } else if (parseInt(value, 10) < 1) {
            // Handle negatives or zero
            this.setState({
                numberOfCopiesToPrint: 1,
                numberOfCopiesToPrintWarning: "Number of copies to print should be greater than 0."
            });
        } else {
            // Valid positive number
            this.setState({
                numberOfCopiesToPrint: parseInt(value, 10),
                numberOfCopiesToPrintWarning: ""
            });
        }
    };

    // getNumberOfCopiesToPrint = (e) => {
    //     this.setState({
    //         numberOfCopiesToPrint: e.target.value
    //     });

    //     if (e.target.value < 1) {
    //         this.setState({
    //             numberOfCopiesToPrintWarning: 'Number of copies to print should be greater than 0.'
    //         });
    //     } else {
    //         this.setState({
    //             numberOfCopiesToPrintWarning: ''
    //         });
    //     }
    // }

    // METHOD TO GET ROWS NUMBER OF COPIES
    getNumberOfCopiesInRow = (e) => {
        const value = e.target.value;

        if (value === "") {
            // Allow empty field, show warning
            this.setState({
                numberOfCopiesInRow: "",
                numberOfCopiesInRowWarning: "Please enter number of copies."
            });
        } else if (parseInt(value, 10) < 1 || parseInt(value, 10) > 30) {
            // Handle negatives or zero
            this.setState({
                numberOfCopiesInRow: 1,
                numberOfCopiesInRowWarning: "Number of copies in row should be between 1 to 30."
            });
        } else {
            // Valid positive number
            this.setState({
                numberOfCopiesInRow: parseInt(value, 10),
                numberOfCopiesInRowWarning: ""
            });
        }
    };

    // getNumberOfCopiesInRow = (e) => {
    //     this.setState({
    //         numberOfCopiesInRow: e.target.value
    //     });

    //     if (e.target.value < 1 || e.target.value > 30) {
    //         this.setState({
    //             numberOfCopiesInRowWarning: 'Number of copies in row should be between 1 to 30.'
    //         });
    //     } else {
    //         this.setState({
    //             numberOfCopiesInRowWarning: ''
    //         });
    //     }
    // }

    // METHOD TO GET NUMBER OF ROWS
    getNumberOfRows = (e) => {
        const value = e.target.value;

        if (value === "") {
            // Allow empty field, show warning
            this.setState({
                numberOfRows: "",
                numberOfRowsWarning: "Please enter number of copies."
            });
        } else if (parseInt(value, 10) < 1 || parseInt(value, 10) > 100) {
            // Handle negatives or zero
            this.setState({
                numberOfRows: 1,
                numberOfRowsWarning: "Number of rows should be between 1 to 100."
            });
        } else {
            // Valid positive number
            this.setState({
                numberOfRows: parseInt(value, 10),
                numberOfRowsWarning: ""
            });
        }
    };

    // getNumberOfRows = (e) => {
    //     this.setState({
    //         numberOfRows: e.target.value
    //     });

    //     if (e.target.value < 1 || e.target.value > 100) {
    //         this.setState({
    //             numberOfRowsWarning: 'Number of rows should be between 1 to 100.'
    //         });
    //     } else {
    //         this.setState({
    //             numberOfRowsWarning: ''
    //         });
    //     }
    // }

    // METHOD TO VALIDATE BARCODE DETAILS
    validateBarcodeDetails = () => {
        let validData = true;

        if (this.state.printWith.length < 1) {
            this.setState({
                printWithWarning: 'Please select option to print barcode.'
            });
            validData = false;
        } else {
            if (this.state.printWith == 'template') {
                if (this.state.template.length < 1) {
                    this.setState({
                        templateWarning: 'Please select template.'
                    });
                    validData = false;
                }
            }

            if (this.state.printWith == 'custom') {
                if (this.state.customHeight < 1) {
                    this.setState({
                        customHeightWarning: 'Barcode height should be greater than 0.'
                    });
                    validData = false;
                }

                if (this.state.customWidth < 1) {
                    this.setState({
                        customWidthWarning: 'Barcode width should be greater than 0.'
                    });
                    validData = false;
                }
            }
        }

        if (this.state.accessionSeries.length < 1) {
            this.setState({
                accessionSeriesWarning: 'Please select accession series.'
            });
            validData = false;
        }

        if (this.state.printBy.length < 1) {
            this.setState({
                printByWarning: 'Please select print by option.'
            });
            validData = false;
        } else {
            if (this.state.printBy == 'range') {
                if (this.state.startNumber < 1) {
                    this.setState({
                        startNumberWarning: 'Start accession number should be greater than 0.'
                    });
                    validData = false;
                }

                if (this.state.endNumber < 1) {
                    this.setState({
                        endNumberWarning: 'End accession number should be greater than 0.'
                    });
                    validData = false;
                }

                if (this.state.startNumber > 0 && this.state.endNumber > 0) {
                    if (parseFloat(this.state.startNumber) > parseFloat(this.state.endNumber)) {
                        this.setState({
                            endNumberWarning: 'End accession number should be greater than start accession number.'
                        });
                        validData = false;
                    }
                }
            } else {
                if (this.state.seriesNumbers.length < 1) {
                    this.setState({
                        seriesIdsWarning: 'Please enter comma separated accession series numbers.'
                    });
                    validData = false;
                } else {
                    if (this.state.seriesNumberIds.includes("")) {
                        this.setState({
                            seriesIdsWarning: 'Please enter value after comma.'
                        });
                        validData = false;
                    }
                }
            }
        }

        if (this.state.numberOfCopiesToPrint < 1) {
            this.setState({
                numberOfCopiesToPrintWarning: 'Number of copies to print should be greater than 0.'
            });
            validData = false;
        }

        if (this.state.numberOfCopiesInRow < 1 || this.state.numberOfCopiesInRow > 30) {
            this.setState({
                numberOfCopiesInRowWarning: 'Number of copies in row should be between 1 to 30.'
            });
            validData = false;
        }

        if (this.state.numberOfRows < 1 || this.state.numberOfRows > 100) {
            this.setState({
                numberOfRowsWarning: 'Number of rows should be between 1 to 100.'
            });
            validData = false;
        }

        if (validData) {
            this.setState({
                showBarcode: true
            }, () => {
                if (this.state.printBy == 'range') {
                    this.apiCallToGetBarcodeDetailsByRange();
                } else {
                    this.apiCallToGetBarcodeDetailsManual();
                }
            });
        }
    }

    // API CALL METHOD TO GET BARCODE DETAILS
    apiCallToGetBarcodeDetailsByRange = async () => {
        this.setState({
            barcodeDetailsFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "startAccesion": this.state.startNumber,
            "accesionnoend": this.state.endNumber,
            "seriesId": this.state.accessionSeries
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getAccessionNumberList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetBarcodeDetailsByRange();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(uniqueId => {
                        apiResult[uniqueId]['uniqueId'] = uniqueId;
                    });
                }
                this.setState({
                    barcodeDetails: apiResult,
                    // barcodeIds: Object.keys(apiResult),
                    barcodeIds: jsonResponse.APIResult.sortedIdArray,
                    barcodeDetailsFetching: false
                });
            } else {
                this.setState({
                    barcodeDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting barcode details. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET BARCODE DETAILS
    apiCallToGetBarcodeDetailsManual = async () => {
        this.setState({
            barcodeDetailsFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "accessionNoArray": this.state.seriesNumberIds,
            "seriesIdArray": [this.state.accessionSeries]
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getResourceDetailsByAccessionNo',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetBarcodeDetailsManual();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(uniqueId => {
                        apiResult[uniqueId]['uniqueId'] = uniqueId;
                    });
                }
                this.setState({
                    barcodeDetails: apiResult,
                    barcodeIds: Object.keys(apiResult),
                    barcodeDetailsFetching: false
                });
            } else {
                this.setState({
                    barcodeDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting barcode details. Please try again later.'
                });
            }
        }
    }

    isAccessionSeriesWithNumberConfigured = () => {
        if (this.state.printWith !== 'template' || this.state.template === '') {
            return false;
        }

        let selectedTemplateData = this.state.templateList[this.state.template];
        if (!selectedTemplateData || !selectedTemplateData.configuration) {
            return false;
        }

        let barcodeConfiguration = selectedTemplateData.configuration.barcodeConfiguration;
        if (typeof barcodeConfiguration !== 'string') {
            return false;
        }

        return barcodeConfiguration.includes('{Accession_Series_With_Number}');
    }

    getResolvedBarcodeValue = (barcodeData) => {       
        if (!barcodeData) {
            return '';
        }

        if (this.isAccessionSeriesWithNumberConfigured() && barcodeData.accessionSeriesWithNumber) {
            return barcodeData.accessionSeriesWithNumber;
        }

        return barcodeData.accessionNumber || '';
    }

    // METHOD TO RETURN SHOW BARCODE
    returnShowBarcode = () => {
        let template = {};
        let replaceString = '';
        let counter = 'na';
        let displayBarcodeArray = [];
        if (this.state.printWith == 'template' && this.state.template != '') {
            template = this.state.templateList[this.state.template];
            replaceString = template.configuration.barcodeConfiguration;
        }

        return (
            <div className={this.state.showBarcode ? "modal fade show" : "modal fade"} id="modalContainer">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content" style={{ height: "calc(100vh - 50px)" }}>
                        <div className="modal-header">
                            <div className="icon-container">
                                Show Barcode
                            </div>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeShowBarcode()} />
                        </div>
                        {
                            this.state.barcodeDetailsFetching ?
                                <Spinner />
                                :
                                <div className="modal-body showBarcodeBody">
                                    <div ref={el => this.printReference = el}>
                                        <table className='table-bordered printTable' style={{ width: '100%', height: '100%' }}>
                                            <tbody>
                                                {
                                                    (this.state.printWith == 'template') ?
                                                        (this.state.numberOfRows != '' && (replaceString == '' || replaceString == undefined)) ?
                                                            [...Array(parseInt(this.state.numberOfRows !== '' ? this.state.numberOfRows : 0))].map((number, numberIndex) => {
                                                                return (

                                                                    // <div className='barcodeGeneration'>
                                                                    <>
                                                                        <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                            {
                                                                                this.state.numberOfCopiesInRow != '' &&
                                                                                [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {

                                                                                    if (this.state.selectedTemplate == `${copiesIndex}-${numberIndex}`) {
                                                                                        counter = 0;
                                                                                        if (counter <= this.state.barcodeIds.length / this.state.numberOfCopiesToPrint) {
                                                                                            let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                            if (barcode != undefined) {
                                                                                                Array(this.state.numberOfCopiesToPrint).map((clone, cloneIndex) => {

                                                                                                    return (
                                                                                                        <>
                                                                                                            <td className="barcodeData" style={{ height: `${parseFloat(template && template.configuration && template.configuration.height !== undefined ? template.configuration.height : 0).toFixed(2)}mm`, width: `${parseFloat(template && template.configuration && template.configuration.width !== undefined ? template.configuration.width : 0).toFixed(2)}mm`, margin: 5 }}>
                                                                                                                <Barcode
                                                                                                                    format="CODE128"
                                                                                                                    displayValue="false"
                                                                                                                    // value={barcode.accessionSeriesWithNumber || barcode.accessionNumber}
                                                                                                                    value={this.getResolvedBarcodeValue(barcode)}
                                                                                                                />
                                                                                                            </td>

                                                                                                            {
                                                                                                                copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                            }

                                                                                                        </>
                                                                                                    );
                                                                                                })
                                                                                            }
                                                                                        } else {
                                                                                            counter = 'na';
                                                                                            if (Object.keys(template).length > 0) {
                                                                                                return (
                                                                                                    <>
                                                                                                        <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>

                                                                                                        </td>

                                                                                                        {
                                                                                                            copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                            <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                        }
                                                                                                    </>
                                                                                                    // <div style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5, background: '#D3D3D3' }}>

                                                                                                    // </div>
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    } else {

                                                                                        if (counter == 'na') {
                                                                                            if (Object.keys(template).length > 0) {
                                                                                                return (
                                                                                                    <>
                                                                                                        <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5, background: '#D3D3D3' }}>

                                                                                                        </td>

                                                                                                        {
                                                                                                            copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                            <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                        }
                                                                                                    </>
                                                                                                    // <div style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5, background: '#D3D3D3' }}>

                                                                                                    // </div>
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                            counter = counter + 1;
                                                                                            if (counter <= this.state.barcodeIds.length) {
                                                                                                let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                                if (barcode != undefined) {
                                                                                                    Array(this.state.numberOfCopiesToPrint).map((clone, cloneIndex) => {

                                                                                                        return (
                                                                                                            <>
                                                                                                                <td className="barcodeData" style={{ height: `${parseFloat(template && template.configuration && template.configuration.height !== undefined ? template.configuration.height : 0).toFixed(2)}mm`, width: `${parseFloat(template && template.configuration && template.configuration.width ? template.configuration.width : 0).toFixed(2)}mm`, margin: 5 }}>
                                                                                                                    <Barcode
                                                                                                                        format="CODE128"
                                                                                                                        displayValue="false"
                                                                                                                        // value={barcode.accessionSeriesWithNumber || barcode.accessionNumber}
                                                                                                                        value={this.getResolvedBarcodeValue(barcode)}
                                                                                                                    />
                                                                                                                </td>

                                                                                                                {
                                                                                                                    copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                    <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                                }
                                                                                                            </>
                                                                                                        );
                                                                                                    });
                                                                                                }
                                                                                            } else {
                                                                                                counter = 'na';
                                                                                                if (Object.keys(template).length > 0) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5, background: '#D3D3D3' }}>

                                                                                                            </td>

                                                                                                            {
                                                                                                                copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                            }
                                                                                                        </>
                                                                                                        // <div style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5, background: '#D3D3D3' }}>

                                                                                                        // </div>
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })

                                                                            }
                                                                        </tr>

                                                                        {
                                                                            numberIndex < (this.state.numberOfRows - 1) &&
                                                                            <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                                {
                                                                                    this.state.numberOfCopiesInRow != '' &&
                                                                                    [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                        return (
                                                                                            <td style={{ height: this.state.verticalGap != '' ? `${parseFloat(this.state.verticalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                        )

                                                                                    })
                                                                                }
                                                                            </tr>

                                                                        }
                                                                    </>
                                                                    // </div>

                                                                );
                                                            })
                                                            :
                                                            (this.state.numberOfRows != '' && replaceString != '') &&
                                                            [...Array(parseInt(this.state.numberOfRows !== '' ? this.state.numberOfRows : 0) * parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0))].map((number, numberIndex) => {

                                                                return (
                                                                    // <div className='barcodeGeneration'>
                                                                    <>
                                                                        <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                            {
                                                                                this.state.numberOfCopiesInRow != '' &&
                                                                                [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {

                                                                                    if (counter != 'na') {
                                                                                        if (this.checkElementOccurrence(displayBarcodeArray, counter) == (parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0) - 1)) {
                                                                                            counter = counter + 1;
                                                                                        }
                                                                                        else {
                                                                                            displayBarcodeArray.push(counter);
                                                                                        }
                                                                                    }

                                                                                    replaceString = template.configuration.barcodeConfiguration;
                                                                                    let barcodeHeight = (this.state.customHeight * (this.state.barcodeHeight != '' ? this.state.barcodeHeight : 100)) / 100;
                                                                                    let barcodeWidth = (this.state.customWidth * (this.state.barcodeWidth != '' ? this.state.barcodeWidth : 100)) / 100;
                                                                                    if (this.state.selectedTemplate == `${copiesIndex}-${numberIndex}`) {
                                                                                        counter = 0;
                                                                                        if (counter < this.state.barcodeIds.length) {
                                                                                            let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                            if (barcode != undefined) {
                                                                                                replaceString = replaceString.replaceAll('{Barcode}', `<div class='barcodeDiv' id=barcode_${barcode.uniqueId}_${copiesIndex}></div>`);
                                                                                                replaceString = replaceString.replaceAll('{Accession_number}', barcode.accessionNumber == undefined ? '' : barcode.accessionNumber);
                                                                                                replaceString = replaceString.replaceAll('{Accession_series}', barcode.accessionSeries == undefined ? '' : barcode.accessionSeries);
                                                                                                replaceString = replaceString.replaceAll('{Call_Index}', barcode.callIndex == undefined ? '' : barcode.callIndex);
                                                                                                replaceString = replaceString.replaceAll('{Call_Number}', barcode.callNumber == undefined ? '' : barcode.callNumber);
                                                                                                replaceString = replaceString.replaceAll('{Author_Three_Letters}', barcode.authorThreeLetters == undefined ? '' : barcode.authorThreeLetters);
                                                                                                replaceString = replaceString.replaceAll('{Author_Full_Name}', barcode.authorFullName == undefined ? '' : barcode.authorFullName);
                                                                                                replaceString = replaceString.replaceAll('{Title_Last_Three_Letters}', barcode?.titleLastThreeLetter == undefined ? '' : barcode?.titleLastThreeLetter);
                                                                                                replaceString = replaceString.replaceAll('{Location}', barcode?.location == undefined ? '' : barcode?.location);
                                                                                                replaceString = replaceString.replaceAll('{Accession_Series_With_Number}', barcode?.accessionSeriesWithNumber == undefined ? '' : barcode?.accessionSeriesWithNumber);
                                                                                                return [Array(parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0))].map((clone, cloneIndex) => {

                                                                                                    return (
                                                                                                        <>
                                                                                                            <td className="barcodeData" style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>
                                                                                                                <div style={{ height: `${barcodeHeight}mm`, width: `${barcodeWidth}mm`, marginLeft: 'auto', marginRight: 'auto' }}>
                                                                                                                    {ReactHtmlParser(replaceString)}
                                                                                                                </div>
                                                                                                            </td>

                                                                                                            {
                                                                                                                copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                            }
                                                                                                        </>
                                                                                                    );
                                                                                                })
                                                                                            }
                                                                                        } else {
                                                                                            counter = 'na';
                                                                                            if (Object.keys(template).length > 0) {
                                                                                                // replaceString = replaceString.replace( /(<([^>]+)>)/ig, '');
                                                                                                let parser = new DOMParser();
                                                                                                let doc = parser.parseFromString(replaceString, 'text/html');
                                                                                                let table = doc.body.firstElementChild;
                                                                                                // let height = table.getAttribute('height');
                                                                                                // let width = table.getAttribute('width');

                                                                                                return (
                                                                                                    <>
                                                                                                        <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>

                                                                                                        </td>

                                                                                                        {
                                                                                                            copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                            <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                        }
                                                                                                    </>
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    } else {
                                                                                        if (counter == 'na') {
                                                                                            if (Object.keys(template).length > 0) {
                                                                                                // replaceString = replaceString.replace( /(<([^>]+)>)/ig, '');
                                                                                                let parser = new DOMParser();
                                                                                                let doc = parser.parseFromString(replaceString, 'text/html');
                                                                                                let table = doc.body.firstElementChild;
                                                                                                // let height = table.getAttribute('height');
                                                                                                // let width = table.getAttribute('width');

                                                                                                return (
                                                                                                    <>
                                                                                                        <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>

                                                                                                        </td>

                                                                                                        {
                                                                                                            copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                            <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                        }
                                                                                                    </>
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                            // counter = counter + 1;                                                                       
                                                                                            if (counter < this.state.barcodeIds.length) {
                                                                                                let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                                if (barcode != undefined) {
                                                                                                    replaceString = replaceString.replaceAll('{Barcode}', `<div class='barcodeDiv' id=barcode_${barcode.uniqueId}_${copiesIndex}></div>`);
                                                                                                    replaceString = replaceString.replaceAll('{Accession_number}', barcode.accessionNumber == undefined ? '' : barcode.accessionNumber);
                                                                                                    replaceString = replaceString.replaceAll('{Accession_series}', barcode.accessionSeries == undefined ? '' : barcode.accessionSeries);
                                                                                                    replaceString = replaceString.replaceAll('{Call_Index}', barcode.callIndex == undefined ? '' : barcode.callIndex);
                                                                                                    replaceString = replaceString.replaceAll('{Call_Number}', barcode.callNumber == undefined ? '' : barcode.callNumber);
                                                                                                    replaceString = replaceString.replaceAll('{Author_Three_Letters}', barcode.authorThreeLetters == undefined ? '' : barcode.authorThreeLetters);
                                                                                                    replaceString = replaceString.replaceAll('{Author_Full_Name}', barcode.authorFullName == undefined ? '' : barcode.authorFullName);
                                                                                                    replaceString = replaceString.replaceAll('{Title_Last_Three_Letters}', barcode?.titleLastThreeLetter == undefined ? '' : barcode?.titleLastThreeLetter);
                                                                                                    replaceString = replaceString.replaceAll('{Location}', barcode?.location == undefined ? '' : barcode?.location);
                                                                                                    replaceString = replaceString.replaceAll('{Accession_Series_With_Number}', barcode?.accessionSeriesWithNumber == undefined ? '' : barcode?.accessionSeriesWithNumber);
                                                                                                    return [Array(parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0))].map((clone, cloneIndex) => {

                                                                                                        return (
                                                                                                            <>
                                                                                                                <td className="barcodeData" style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>
                                                                                                                    <div style={{ height: `${barcodeHeight}mm`, width: `${barcodeWidth}mm`, marginLeft: 'auto', marginRight: 'auto' }}>
                                                                                                                        {ReactHtmlParser(replaceString)}
                                                                                                                    </div>
                                                                                                                </td>

                                                                                                                {
                                                                                                                    copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                    <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                                }
                                                                                                            </>
                                                                                                        );
                                                                                                    })

                                                                                                }
                                                                                            } else {
                                                                                                counter = 'na';
                                                                                                if (Object.keys(template).length > 0) {
                                                                                                    // replaceString = replaceString.replace( /(<([^>]+)>)/ig, '');
                                                                                                    let parser = new DOMParser();
                                                                                                    let doc = parser.parseFromString(replaceString, 'text/html');
                                                                                                    let table = doc.body.firstElementChild;
                                                                                                    // let height = table.getAttribute('height');
                                                                                                    // let width = table.getAttribute('width');

                                                                                                    return (
                                                                                                        <>
                                                                                                            <td style={{ height: `${parseFloat(template.configuration.height).toFixed(2)}mm`, width: `${parseFloat(template.configuration.width).toFixed(2)}mm`, margin: 5 }}>
                                                                                                                {/* {replaceString} */}
                                                                                                            </td>

                                                                                                            {
                                                                                                                copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                                <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                            }
                                                                                                        </>
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        </tr>

                                                                        {
                                                                            numberIndex < (this.state.numberOfRows - 1) &&
                                                                            <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                                {
                                                                                    this.state.numberOfCopiesInRow != '' &&
                                                                                    [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                        return (
                                                                                            <td style={{ height: this.state.verticalGap != '' ? `${parseFloat(this.state.verticalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                        )

                                                                                    })
                                                                                }
                                                                            </tr>

                                                                        }
                                                                    </>
                                                                    // </div>
                                                                );
                                                            })
                                                        :
                                                        (this.state.printWith == 'custom' || this.state.printWith == 'default') &&
                                                        (this.state.numberOfRows != '' && this.state.numberOfCopiesToPrint != '') &&
                                                        [...Array(parseInt(this.state.numberOfRows !== '' ? this.state.numberOfRows : 0) * parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0))].map((number, numberIndex) => {
                                                            return (
                                                                // <div className='barcodeGeneration' style={{ width: `${parseFloat()}` }}>
                                                                <>
                                                                    <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                        {
                                                                            this.state.numberOfCopiesInRow != '' &&

                                                                            [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                let barcodeHeight = (this.state.customHeight * (this.state.barcodeHeight != '' ? this.state.barcodeHeight : 100)) / 100;

                                                                                if (counter != 'na') {
                                                                                    if (this.checkElementOccurrence(displayBarcodeArray, counter) == (parseInt(this.state.numberOfCopiesToPrint !== '' ? this.state.numberOfCopiesToPrint : 0) - 1)) {
                                                                                        counter = counter + 1;
                                                                                    }
                                                                                    else {
                                                                                        displayBarcodeArray.push(counter);
                                                                                    }
                                                                                }

                                                                                if (this.state.selectedTemplate == `${copiesIndex}-${numberIndex}`) {
                                                                                    counter = 0;
                                                                                    if (counter <= this.state.barcodeIds.length) {
                                                                                        let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                        if (barcode != undefined) {
                                                                                            return (
                                                                                                <>
                                                                                                    <td className="barcodeData" style={{ height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, margin: 5 }}>
                                                                                                        <Barcode
                                                                                                            format="CODE128"
                                                                                                            displayValue={true}
                                                                                                            // value={barcode.accessionSeriesWithNumber || barcode.accessionNumber}
                                                                                                            value={this.getResolvedBarcodeValue(barcode)}
                                                                                                            height={barcodeHeight + "mm"}
                                                                                                            margin={0}
                                                                                                            marginTop={1}
                                                                                                            marginBottom={1}
                                                                                                            marginRight={5}
                                                                                                            marginLeft={5}
                                                                                                        />
                                                                                                    </td>

                                                                                                    {
                                                                                                        copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                        <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                    }
                                                                                                </>
                                                                                            );
                                                                                        }
                                                                                    } else {
                                                                                        counter = 'na';
                                                                                        return (
                                                                                            <>
                                                                                                <td style={{ height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, margin: 5 }}>
                                                                                                </td>

                                                                                                {
                                                                                                    copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                    <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                }
                                                                                            </>
                                                                                        );
                                                                                    }
                                                                                } else {
                                                                                    if (counter == 'na') {
                                                                                        return (
                                                                                            <>
                                                                                                <td style={{ height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, margin: 5 }}>
                                                                                                </td>

                                                                                                {
                                                                                                    copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                    <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                }
                                                                                            </>
                                                                                        );
                                                                                    } else {
                                                                                        // counter = counter + 1;                                                                            
                                                                                        if (counter <= this.state.barcodeIds.length) {
                                                                                            let barcode = this.state.barcodeDetails[this.state.barcodeIds[counter]];
                                                                                            if (barcode != undefined) {
                                                                                                return (
                                                                                                    <>
                                                                                                        <td className="barcodeData" style={{ height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, margin: 5 }}>
                                                                                                            <Barcode
                                                                                                                format="CODE128"
                                                                                                                displayValue={true}
                                                                                                                // value={barcode.accessionSeriesWithNumber || barcode.accessionNumber}
                                                                                                                value={this.getResolvedBarcodeValue(barcode)}
                                                                                                                height={barcodeHeight + "mm"}
                                                                                                                margin={0}
                                                                                                                marginTop={1}
                                                                                                                marginBottom={1}
                                                                                                                marginRight={5}
                                                                                                                marginLeft={5}
                                                                                                            />
                                                                                                        </td>

                                                                                                        {
                                                                                                            copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                            <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                        }
                                                                                                    </>
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                            counter = 'na';
                                                                                            return (
                                                                                                <>
                                                                                                    <td style={{ height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, margin: 5 }}>

                                                                                                    </td>

                                                                                                    {
                                                                                                        copiesIndex < (this.state.numberOfCopiesInRow - 1) &&
                                                                                                        <td style={{ width: this.state.horizontalGap != '' ? `${parseFloat(this.state.horizontalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                                    }
                                                                                                </>
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })


                                                                        }
                                                                    </tr>

                                                                    {
                                                                        numberIndex < (this.state.numberOfRows - 1) &&
                                                                        <tr className={this.state.stickerPageBreak ? 'stickerPageBreak' : ''}>
                                                                            {
                                                                                this.state.numberOfCopiesInRow != '' &&
                                                                                [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                    return (
                                                                                        <td style={{ height: this.state.verticalGap != '' ? `${parseFloat(this.state.verticalGap).toFixed(2)}mm` : '0px' }}></td>
                                                                                    )

                                                                                })
                                                                            }
                                                                        </tr>
                                                                    }
                                                                </>
                                                                // </div>
                                                            );
                                                        })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                        }
                        {
                            this.state.barcodeDetailsFetching ? null
                                : 
                                (
                                    <div className="modal-footer successFooter">
                                        {
                                            this.state.printWith == 'custom' ?
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <button className="btn btn-outline-primary waves-effect" title="Click to print barcode.">
                                                                Print
                                                            </button>
                                                        );
                                                    }}
                                                    pageStyle={`@page { size: ${parseFloat(this.state.customWidth) * parseFloat(this.state.numberOfCopiesInRow)}mm 100% !important; }`}
                                                    // pageStyle={`@page { size: 8.3in 11.7in !important; }`}
                                                    content={() => this.printReference}
                                                />
                                                :
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <button className="btn btn-outline-primary waves-effect" title="Click to print barcode.">
                                                                Print
                                                            </button>
                                                        );
                                                    }}
                                                    // pageStyle={`@page { size: ${(template != undefined && template.configuration != undefined) ? (parseFloat(template.configuration.width) * parseFloat(this.state.numberOfCopiesInRow)) : 0}mm 100% !important; }`}
                                                    pageStyle={`@page { size: ${(this.state.pageWidth != '') ? (this.state.pageWidth + 'mm') : '100%'} ${(this.state.pageHeight != '') ? (this.state.pageHeight + 'mm') : '100%'} !important; }`}
                                                    content={() => this.printReference}
                                                />
                                        }
                                        <button className="btn outline-button" onClick={() => this.closeShowBarcode()}>Cancel</button>
                                    </div>
                                )
                        }
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO REPLACE BARCODE
    replaceBarcode = () => {
        let template = {};
        let height = '';
        let barcodeHeightPercentage = '';

        if (this.state.printWith == 'template' && this.state.template != '') {
            template = this.state.templateList[this.state.template];
            height = template.configuration.height;
            barcodeHeightPercentage = this.state.barcodeHeight;
        }

        let barcodeHeight = (height * barcodeHeightPercentage) / 100;

        Object.values(this.state.barcodeDetails).map(barcodeData => {
            let barcode = <Barcode
                format="CODE128"
                displayValue={false}
                // value={barcodeData.accessionSeriesWithNumber || barcodeData.accessionNumber}
                value={this.getResolvedBarcodeValue(barcodeData)}
                // height={(barcodeHeight * 3.77).toFixed(2)}
                height={barcodeHeight + 'mm'}
                margin={0}
                marginTop={1}
                marginBottom={1}
                marginRight={5}
                marginLeft={5}
            />;

            [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((column, columnIndex) => {
                if (document.getElementById(`barcode_${barcodeData.uniqueId}_${columnIndex}`) != null) {
                    ReactDOM.render(barcode, document.getElementById(`barcode_${barcodeData.uniqueId}_${columnIndex}`));
                }
            })

        });
    }

    checkElementOccurrence = (array, element) => {
        let counter = 0;
        for (let item of array.flat()) {
            if (item == element) {
                counter++;
            }
        };
        return counter;
    }

    // METHOD TO CLOSE SHOW BARCODE
    closeShowBarcode = () => {
        this.setState({
            showBarcode: false
        });
    }

    // METHOD TO CLOSE TEMPLATE MANAGEMENT PAGE
    closeTemplateManagement = () => {
        this.setState({
            manageTemplate: false,
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO DISPLAY PRINT WITH INFO
    displayPrintInfo = () => {
        this.setState({
            successModal: true,
            successModalType: 'information',
            successMessage: '<li>Institute templates are the templates that are designed using Template Management option.</li><li>Default templates are the standard template sizes available.</li>'
        });
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="printBarcode" />
                <div className="libraryComponents-container">
                    {
                        this.state.manageTemplate ?
                            <div className="formFields-container">
                                <ManageTemplate
                                    closeTemplateManagement={this.closeTemplateManagement}
                                />
                            </div>
                            :
                            <>
                                <div className="libraryComponents">
                                    <div className="add-buttons col-md-12" >
                                        <div className="col-md-6" style={{ paddingLeft: 0 }}>
                                            <h4 >Print Barcode</h4>
                                        </div>
                                        <div className="col-md-6 add-button" style={{ paddingRight: 0 }}>
                                            <button className="btn outline-button" title="Click to add form" onClick={() => this.setState({ manageTemplate: true })}>
                                                Template Management
                                            </button>
                                        </div>
                                    </div>
                                    <div className='col-md-12' style={{ display: 'flex' }}>
                                        <span className='col-md-3' style={{ fontWeight: 'bold', fontSize: '16px', padding: 0 }}>Parameters</span>
                                        <span className='col-md-9' style={{ fontWeight: 'bold', fontSize: '16px' }}>Barcode Preview</span>
                                    </div>
                                    <div className="printBarcodeContainer col-md-12" style={{ display: 'flex' }}>
                                        <div className="col-md-3 printContainer" style={{ padding: 0, background: '#f3f5f7' }}>
                                            <div className="selectTemplate">
                                                <div className={this.state.printWith == 'template' ? "printWithSelection col-md-12" : "printWithSelection col-md-12"}>
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0 }}>Print With <span style={{ color: 'red' }}>*</span></label>
                                                    <span style={{ marginLeft: '10px' }}>
                                                        <FontAwesomeIcon icon={['fas', 'info-circle']} style={{ cursor: 'pointer' }} size="sm" onClick={() => this.displayPrintInfo()} />
                                                    </span>
                                                    <select
                                                        className="form-control printBarcodeInput"
                                                        value={this.state.printWith}
                                                        onChange={(e) => this.selectPrintWith(e)}
                                                    >
                                                        <option value="">Select Print With</option>
                                                        <option value="template">Institute Template</option>
                                                        <option value="default">Default Template</option>
                                                        {/* <option value="custom">Custom</option> */}
                                                    </select>
                                                    <p style={{ display: this.state.printWithWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.printWithWarning}</p>
                                                </div>
                                                {
                                                    (this.state.printWith == 'template' || this.state.printWith == 'default') &&
                                                    <div className="templateSelection col-md-12">
                                                        <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0 }}>Template <span style={{ color: 'red' }}>*</span></label>
                                                        <select
                                                            className="form-control printBarcodeInput"
                                                            value={this.state.template}
                                                            onChange={(e) => this.selectTemplate(e)}
                                                        >
                                                            <option value="">Select Template</option>
                                                            {
                                                                this.state.templateList &&
                                                                    this.state.printWith == 'template' ?
                                                                    Object.keys(this.state.templateList).map(templateId => {
                                                                        let templateData = this.state.templateList[templateId];
                                                                        return (
                                                                            <option value={templateId}>{templateData.templateName}</option>
                                                                        );
                                                                    })
                                                                    :
                                                                    Object.keys(this.state.defaultTemplate).map(templateId => {
                                                                        let templateData = this.state.defaultTemplate[templateId];
                                                                        return (
                                                                            <option value={templateId}>{templateData.templateName}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                        <p style={{ display: this.state.templateWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.templateWarning}</p>
                                                    </div>
                                                }
                                                <div className="barcodeHeight col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Sticker Height in mm (Millimeter) <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter height in mm"
                                                        value={this.state.customHeight}
                                                        onChange={(e) => this.getCustomHeight(e)}
                                                        disabled={this.state.printWith == "template" ? true : false}
                                                    />
                                                    <p style={{ display: this.state.customHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customHeightWarning}</p>
                                                </div>
                                                <div className="barcodeWidth col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Sticker Width in mm (Millimeter) <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter width in mm"
                                                        value={this.state.customWidth}
                                                        onChange={(e) => this.getCustomWidth(e)}
                                                        disabled={this.state.printWith == "template" ? true : false}
                                                    />
                                                    <p style={{ display: this.state.customWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customWidthWarning}</p>
                                                </div>
                                                <div className="barcodeHeight col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Barcode Height in % (With reference to sticker) <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter barcode height in %"
                                                        value={this.state.barcodeHeight}
                                                        onChange={(e) => this.getBarcodeHeight(e)}
                                                    // disabled={(this.state.printWith == "template" && this.state.barcodeHeight != "") ? true : false}
                                                    />
                                                    <p style={{ display: this.state.customHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customHeightWarning}</p>
                                                </div>
                                                <div className="barcodeWidth col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Barcode Width in % (With reference to sticker) <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter barcode width in %"
                                                        value={this.state.barcodeWidth}
                                                        onChange={(e) => this.getBarcodeWidth(e)}
                                                    // disabled={(this.state.printWith == "template" && this.state.barcodeWidth != "") ? true : false}
                                                    />
                                                    <p style={{ display: this.state.customWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customWidthWarning}</p>
                                                </div>
                                                <div className="barcodeHeight col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Horizontal Gap between stickers (in mm)</label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter horizontal gap in mm"
                                                        value={this.state.horizontalGap}
                                                        onChange={(e) => this.getHorizontalGap(e)}
                                                    />
                                                </div>
                                                <div className="barcodeWidth col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Vertical Gap between stickers (in mm)</label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter vertical gap in mm"
                                                        value={this.state.verticalGap}
                                                        onChange={(e) => this.getVerticalGap(e)}
                                                    />
                                                </div>
                                                <div className='col-md-12' style={{ padding: 0, display: 'flex' }}>
                                                    <div className="startNumber col-md-6">
                                                        <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Page Height (in mm)</label>
                                                        <input
                                                            type="text"
                                                            className="form-control printBarcodeInput"
                                                            placeholder="Enter page height in mm"
                                                            value={this.state.pageHeight}
                                                            onChange={(e) => this.getPageHeight(e)}
                                                        />
                                                        <p style={{ display: this.state.pageHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.pageHeightWarning}</p>
                                                    </div>
                                                    <div className="endNumber col-md-6">
                                                        <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Page Width (in mm)</label>
                                                        <input
                                                            type="text"
                                                            className="form-control printBarcodeInput"
                                                            placeholder="Enter page width in mm"
                                                            value={this.state.pageWidth}
                                                            onChange={(e) => this.getPageWidth(e)}
                                                        />
                                                        <p style={{ display: this.state.pageWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.pageWidthWarning}</p>
                                                    </div>
                                                </div>
                                                <div className='col-md-12' style={{ padding: 0, display: 'flex' }}>
                                                    <div className="startNumber col-md-12">
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.stickerPageBreak}
                                                            onChange={(e) => this.setStickerPageBreak(e)}
                                                        />
                                                        <span style={{ fontSize: '14px' }}> Confirm if barcode to be printed on new page after every row</span>
                                                    </div>
                                                </div>
                                                {/* {
                                                    this.state.printWith == 'custom' &&
                                                        <>
                                                            <div className="barcodeHeight col-md-12">
                                                                <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Height in mm (Millimeter) <span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control printBarcodeInput" 
                                                                    placeholder="Enter height in mm"
                                                                    value={this.state.customHeight}
                                                                    onChange={(e) => this.getCustomHeight(e)}
                                                                />
                                                                <p style={{ display: this.state.customHeightWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customHeightWarning}</p>
                                                            </div>
                                                            <div className="barcodeWidth col-md-12">
                                                                <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Width in mm (Millimeter) <span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control printBarcodeInput" 
                                                                    placeholder="Enter width in mm"
                                                                    value={this.state.customWidth}
                                                                    onChange={(e) => this.getCustomWidth(e)}
                                                                />
                                                                <p style={{ display: this.state.customWidthWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.customWidthWarning}</p>
                                                            </div>
                                                        </>
                                                } */}
                                            </div>
                                            <div className="accessionSeriesConfig">
                                                <div className={this.state.printBy == 'range' ? "accessionSeriesSelection col-md-12" : "accessionSeriesSelection col-md-12"}>
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Accession Series <span style={{ color: 'red' }}>*</span></label>
                                                    <select
                                                        className="form-control printBarcodeInput"
                                                        value={this.state.accessionSeries}
                                                        onChange={(e) => this.selectAccessionSeries(e)}
                                                    >
                                                        <option value="">Select Accession Series</option>
                                                        {
                                                            Object.keys(this.state.accessionSeriesList) &&
                                                            Object.values(this.state.accessionSeriesList).map(series => {
                                                                return (
                                                                    <option key={series.seriesId} value={series.seriesId}>{series.seriestext}</option>
                                                                );
                                                            })
                                                        }
                                                    </select>
                                                    <p style={{ display: this.state.accessionSeriesWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.accessionSeriesWarning}</p>
                                                </div>
                                                <div className={this.state.printBy == 'range' ? "pintBySelection col-md-12" : "pintBySelection col-md-12"}>
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0 }}>Print By <span style={{ color: 'red' }}>*</span></label>
                                                    <select
                                                        className="form-control printBarcodeInput"
                                                        value={this.state.printBy}
                                                        onChange={(e) => this.selectPrintByOption(e)}
                                                    >
                                                        <option value="range">Accession Number Range</option>
                                                        <option value="manual">Enter Accession Number Manually</option>
                                                    </select>
                                                    <p style={{ display: this.state.printByWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.printByWarning}</p>
                                                </div>
                                                {
                                                    this.state.printBy == 'range' ?
                                                        <>
                                                            <div className='col-md-12' style={{ padding: 0, display: 'flex' }}>
                                                                <div className="startNumber col-md-6">
                                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Start Accession Number <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control printBarcodeInput"
                                                                        placeholder="Enter start accession number"
                                                                        value={this.state.startNumber}
                                                                        onChange={(e) => this.getStartAccessionNumber(e)}
                                                                    />
                                                                    <p style={{ display: this.state.startNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.startNumberWarning}</p>
                                                                </div>
                                                                <div className="endNumber col-md-6">
                                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>End Accession Number <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control printBarcodeInput"
                                                                        placeholder="Enter end accession number"
                                                                        value={this.state.endNumber}
                                                                        onChange={(e) => this.getEndAccessionNumber(e)}
                                                                    />
                                                                    <p style={{ display: this.state.endNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.endNumberWarning}</p>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="seriesNumbers col-md-12">
                                                            <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Accession Numbers <span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control printBarcodeInput"
                                                                placeholder="Enter end accession number"
                                                                value={this.state.seriesNumbers}
                                                                onChange={(e) => this.getAccessionSeriesNumbers(e)}
                                                            />
                                                            <p style={{ display: this.state.seriesIdsWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.seriesIdsWarning}</p>
                                                        </div>
                                                }
                                            </div>
                                            <div className="copiesDetails">
                                                <div className="copiesPerCode col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>No. of Barcode copies of a accession number <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter no. of copies to print"
                                                        value={this.state.numberOfCopiesToPrint}
                                                        onChange={(e) => this.getNumberOfCopiesToPrint(e)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault(); // ❌ block negative sign and exponent
                                                            }
                                                        }}
                                                        min={1}
                                                    />
                                                    <p style={{ display: this.state.numberOfCopiesToPrintWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.numberOfCopiesToPrintWarning}</p>
                                                </div>
                                                <div className="copiesPerRow col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>No. of Columns (No. of Barcode copies in one row) <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter no. of copies in one row"
                                                        value={this.state.numberOfCopiesInRow}
                                                        onChange={(e) => this.getNumberOfCopiesInRow(e)}
                                                       onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault(); // ❌ block negative sign and exponent
                                                            }
                                                        }}
                                                        min={1}
                                                        max={30}
                                                    />
                                                    <p style={{ display: this.state.numberOfCopiesInRowWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.numberOfCopiesInRowWarning}</p>
                                                </div>
                                                <div className="numberOfRows col-md-12">
                                                    <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>No. of Rows <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control printBarcodeInput"
                                                        placeholder="Enter no. of rows"
                                                        value={this.state.numberOfRows}
                                                        onChange={(e) => this.getNumberOfRows(e)}
                                                       onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault(); // ❌ block negative sign and exponent
                                                            }
                                                        }}
                                                        min={1}
                                                        max={100}
                                                    />
                                                    <p style={{ display: this.state.numberOfRowsWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 14 }}>{this.state.numberOfRowsWarning}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-9'>
                                            <div className="markPositionToPrint col-md-12">
                                                {
                                                    (this.state.printWith != '' && this.state.numberOfCopiesInRow > 0 && this.state.numberOfRows > 0) ?
                                                        <>
                                                            <label style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 0, textTransform: 'none' }}>Mark position from where you want to start printing <span style={{ color: 'red' }}>*</span></label>
                                                            <div className="barcodeSelection-container">
                                                                <div className="barcodeSelectionPrint">
                                                                    {
                                                                        this.state.printWith == 'template' ?
                                                                            [...Array(parseInt(this.state.numberOfRows !== '' ? this.state.numberOfRows : 0))].map((number, numberIndex) => {
                                                                                return (
                                                                                    <div className='barcodeGeneration'>
                                                                                        {
                                                                                            [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                                let template = this.state.templateList[this.state.template];
                                                                                                if (template != undefined) {
                                                                                                    return (
                                                                                                        <div key={copiesIndex} style={{ background: this.state.selectedTemplate == `${copiesIndex}-${numberIndex}` ? '#4682B4' : '#D3D3D3', margin: 5 }} id={copiesIndex + 1} onClick={() => this.setState({ selectedTemplate: `${copiesIndex}-${numberIndex}` })}>
                                                                                                            {ReactHtmlParser(template.configuration.barcodeConfiguration)}
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                );
                                                                            })
                                                                            :
                                                                            ((this.state.printWith == 'custom' || this.state.printWith == 'default') && this.state.customWidth > 0 && this.state.customHeight > 0) &&
                                                                            [...Array(parseInt(this.state.numberOfRows !== '' ? this.state.numberOfRows : 0))].map((number, numberIndex) => {
                                                                                return (
                                                                                    <div className='barcodeGeneration'>
                                                                                        {
                                                                                            [...Array(parseInt(this.state.numberOfCopiesInRow !== '' ? this.state.numberOfCopiesInRow : 0))].map((copies, copiesIndex) => {
                                                                                                return (
                                                                                                    <div key={copiesIndex} style={{ width: `${parseFloat(this.state.customWidth).toFixed(2)}mm`, height: `${parseFloat(this.state.customHeight).toFixed(2)}mm`, background: this.state.selectedTemplate == `${copiesIndex}-${numberIndex}` ? '#4682B4' : '#D3D3D3', margin: 5 }} id={copiesIndex + 1} onClick={() => this.setState({ selectedTemplate: `${copiesIndex}-${numberIndex}` })}>

                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                );
                                                                            })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <span>Kindly apply the parameters to preview the barcode.</span>
                                                }
                                            </div>
                                            {
                                                this.state.selectedTemplate != '' &&
                                                <div className="showBarcode">
                                                    <button className="btn outline-button" onClick={() => this.validateBarcodeDetails()}>
                                                        <FontAwesomeIcon icon={['fas', 'barcode']} style={{ marginRight: 5 }} />
                                                            Show Barcode
                                                        </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
                {
                    this.returnShowBarcode()
                }
                {
                    this.state.successModal && this.state.successModalType != 'information' ?
                        <SuccessModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                        :
                        <InformationModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                }
            </>
        );
    }
}

export default PrintBarcode;